var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 36,
    viewBox: "0 0 180 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90683 11.9599L11.3395 9.40349L8.86525 5.12032H32.1348L20.5038 25.2728L18.0295 20.9821L13.5969 23.546L20.5038 35.5061L41 0H0L6.90683 11.9599Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3895 29L68.2395 8H64.0095L57.7695 23.24L51.4995 8H47.2695L56.1195 29H59.3895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2434 8V29H88.8734V25.28H77.2634V20.24H87.0734V16.52H77.2634V11.72H88.7234V8H73.2434Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6419 8V29H98.6619V21.59H103.552L107.962 29H112.432L107.632 20.9C110.062 19.82 111.622 17.51 111.622 14.78C111.622 12.86 110.932 11.24 109.522 9.95C108.142 8.66 106.432 8 104.362 8H94.6419ZM104.362 11.72C106.132 11.72 107.422 13.01 107.422 14.78C107.422 16.55 106.132 17.87 104.362 17.87H98.6619V11.72H104.362Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.181 11.72V29H127.231V11.72H134.191V8H116.221V11.72H123.181Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.665 8V29H155.295V25.28H143.685V20.24H153.495V16.52H143.685V11.72H155.145V8H139.665Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.394 18.29L159.594 29H164.424L169.794 21.59L175.164 29H179.964L172.194 18.29L179.664 8H174.864L169.794 14.99L164.724 8H159.894L167.394 18.29Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.7dcf84c921db4f875429b76a2c012d09.svg";
export { ForwardRef as ReactComponent };